import React from 'react'

import { string } from 'prop-types'

import PromoCard from 'Pods/NewHomepage/Components/ModelFilters/PromoCard'
import BookDiscountIcon from 'Pods/NewHomepage/Icons/BookDiscountIcon'
import FlowerDownloadIcon from 'Pods/NewHomepage/Icons/FlowerDownloadIcon'
import i18n from 'Pods/Shared/I18nHome'
import { printModelsPath } from 'Pods/Shared/paths'

function PromoCards({ freeItems = '', onSale = '', locale = 'en' }) {
  const onSaleTitle = i18n.t('modelFilters.promoCards.sale', { ns: 'new-home', lng: locale })
  const freeItemsTitle = i18n.t('modelFilters.promoCards.free', { ns: 'new-home', lng: locale })
  const browseAllButtonPath = printModelsPath(locale)

  return (
    <div className="categories-section__promo-cards">
      <PromoCard
        href={`${browseAllButtonPath}?sale_off=1`}
        variant="sale"
        icon={BookDiscountIcon}
        title={onSaleTitle}
        badge={onSale}
      />
      <PromoCard
        href={`${browseAllButtonPath}?free=1`}
        variant="free"
        icon={FlowerDownloadIcon}
        title={freeItemsTitle}
        badge={freeItems}
      />
    </div>
  )
}

PromoCards.displayName = 'PromoCards'

PromoCards.propTypes = {
  freeItems: string,
  onSale: string,
  locale: string,
}

export default PromoCards
